import { render, staticRenderFns } from "./NavigationList.vue?vue&type=template&id=35c3b026&scoped=true"
import script from "./NavigationList.vue?vue&type=script&lang=js"
export * from "./NavigationList.vue?vue&type=script&lang=js"
import style0 from "./NavigationList.vue?vue&type=style&index=0&id=35c3b026&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c3b026",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35c3b026')) {
      api.createRecord('35c3b026', component.options)
    } else {
      api.reload('35c3b026', component.options)
    }
    module.hot.accept("./NavigationList.vue?vue&type=template&id=35c3b026&scoped=true", function () {
      api.rerender('35c3b026', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/navigation/NavigationList.vue"
export default component.exports